export const dayShowSteps = [
  { cohort: "all", section: "outcomes" },
  { cohort: "statistics", section: "outcomes" },
  { cohort: "statistics", section: "quality" },
  { cohort: "should", section: "goals" },
  { cohort: "common", section: "quality" },
];
export function dayNarrative(data, cohort, section, language = "de") {
  const en = language === "en",
    d = data?.cohorts?.[cohort] || (cohort === "all" ? data : null),
    n = d?.finished_fixtures ?? 0;
  const names = en
    ? {
        all: "all selected games",
        statistics: "games with statistics-model forecasts",
        should: "games with Should Goals",
        common: "games covered by every source",
      }
    : {
        all: "alle ausgewählten Spiele",
        statistics: "Spiele mit Statistikmodell",
        should: "Spiele mit Should Goals",
        common: "Spiele mit allen Vergleichsgrundlagen",
      };
  const f = (v, digits = 2) =>
    Number.isFinite(v)
      ? v.toLocaleString(en ? "en-GB" : "de-DE", {
          maximumFractionDigits: digits,
        })
      : "—";
  const signed = (v) => (v > 0 ? "+" : "") + f(v);
  const intro = en
    ? `Selection: ${names[cohort]}, ${n} games. All sections use this selection.`
    : `Auswahl: ${names[cohort]}, ${n} Spiele. Alle Bereiche verwenden diese Auswahl.`;
  if (!n)
    return (
      intro +
      " " +
      (en
        ? "No comparable stored data available."
        : "Keine vergleichbaren gespeicherten Daten vorhanden.")
    );
  const block = (k) => d.sections?.[k]?.available;
  const labels = en
    ? {
        result: "Results model",
        statistics: "Statistics model",
        market: "Market",
        adaptive_should: "Should Goals",
      }
    : {
        result: "Ergebnismodell",
        statistics: "Statistikmodell",
        market: "Markt",
        adaptive_should: "Should Goals",
      };
  let lines = [];
  if (section === "outcomes") {
    const a = block("outcomes")?.actual;
    lines.push(
      en
        ? `Observed: ${f(a?.home_wins, 0)} home wins, ${f(
            a?.draws,
            0
          )} draws, ${f(a?.away_wins, 0)} away wins.`
        : `Eingetreten: ${f(a?.home_wins, 0)} Heimsiege, ${f(
            a?.draws,
            0
          )} Remis, ${f(a?.away_wins, 0)} Auswärtssiege.`
    );
    for (const [k, m] of Object.entries(block("outcomes")?.models || {}))
      if (m.count === n && m.values) {
        const dif = [
          a.home_wins - m.values.home,
          a.draws - m.values.draw,
          a.away_wins - m.values.away,
        ];
        lines.push(
          `${labels[k]}: ${f(m.values.home)} / ${f(m.values.draw)} / ${f(
            m.values.away
          )} ${
            en
              ? "expected; observed minus expected"
              : "erwartet; eingetreten minus erwartet"
          }: ${dif.map(signed).join(" / ")}.`
        );
      }
  } else if (section === "goals") {
    const a = block("goals")?.actual;
    lines.push(
      en
        ? `Observed goals: ${f(a?.goals, 0)}, average ${f(a?.goal_average)}.`
        : `Eingetretene Tore: ${f(a?.goals, 0)}, Torschnitt ${f(
            a?.goal_average
          )}.`
    );
    for (const [k, m] of Object.entries({
      ...block("goals")?.models,
      adaptive_should: block("should")?.models?.adaptive_should,
    }))
      if (m?.count === n && m.values)
        lines.push(
          `${labels[k]}: ${f(m.values.total)} ${
            en ? "goals; difference" : "Tore; Differenz"
          } ${signed(a.goals - m.values.total)}.`
        );
  } else {
    for (const [k, m] of Object.entries(block("probabilities")?.models || {})) {
      if (m.count !== n || !m.values) continue;
      const v = block("deviation")?.models?.[k];
      lines.push(
        `${labels[k]}: AEP ${f(m.values.expected * 100)} %, AOP ${f(
          m.values.occurred * 100
        )} %, Δ ${signed((m.values.occurred - m.values.expected) * 100)}. ${
          en
            ? "Goal deviation expected / observed"
            : "Torabweichung erwartet / eingetreten"
        }: ${f(v?.values?.expected)} / ${f(v?.values?.occurred)}${
          v?.count === v?.values?.expected_count
            ? " · Δ " + signed(v.values.occurred - v.values.expected)
            : ""
        }.`
      );
    }
    lines.push(
      en
        ? "A smaller absolute gap means closer agreement on this sample, not proof that a model is generally better."
        : "Eine kleinere absolute Differenz bedeutet auf dieser Auswahl eine engere Übereinstimmung, keinen allgemeinen Überlegenheitsnachweis."
    );
  }
  return [
    intro,
    ...lines,
    en
      ? "Sources with incomplete coverage are excluded from direct comparisons."
      : "Quellen mit unvollständiger Abdeckung werden nicht direkt verglichen.",
  ].join(" ");
}
